import clsx from 'clsx';

interface LoadingSpinnerProps {
    className?: string;
    size?: 'sm' | 'md' | 'lg';
}

export const LoadingSpinner = ({ className, size = 'md' }: LoadingSpinnerProps) => {
    const sizeClasses = {
        sm: 'w-5 h-5',
        md: 'w-8 h-8',
        lg: 'w-12 h-12'
    };

    return (
        <div className={clsx("flex justify-center items-center p-4", className)}>
            <div className={clsx(
                "animate-spin rounded-full border-b-2 border-primary",
                sizeClasses[size]
            )} />
        </div>
    );
};
